/**
 * Auth Hook.
 *
 * Convenience wrapper around the auth store that provides a clean
 * interface for components to access authentication state and actions.
 */

import { useAuthStore } from "@/stores/authStore";

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const token = useAuthStore((s) => s.token);
  const isLoading = useAuthStore((s) => s.isLoading);
  const isInitialized = useAuthStore((s) => s.isInitialized);
  const login = useAuthStore((s) => s.login);
  const logout = useAuthStore((s) => s.logout);
  const initialize = useAuthStore((s) => s.initialize);

  return {
    user,
    token,
    isLoading,
    isInitialized,
    isAuthenticated: !!user,
    login,
    logout,
    initialize,
  };
}
